import { memo } from "react";
import RadioElement from "components/Elements/RadioElement/RadioElement";
import SectionTitle from "components/Pages/Purchases_new/components/SectionTitle";
import useCreditCard from "components/Pages/Purchases_new/hooks/useCreditCard";
import {
  PaymentTypeE,
  PurchaseStepE,
} from "components/Pages/Purchases_new/models/enums";
import { useContent } from "contexts/contentContext/contentContext";
import Image from "components/Elements/Image/Image";

import styles from "../../paymentMethodSection.module.scss";

const FirstStepSection = memo(() => {
  const { paymentType, setPaymentType } = useCreditCard();
  const { getTextByKey } = useContent();

  return (
    <>
      <SectionTitle
        titleTextKey="purchase-payment-method-title"
        step={PurchaseStepE.FIRST_PURCHASE_METHOD_STEP}
        className={`${styles.customTitle}`}
      />
      <div className={styles.radioWrap}>
        <RadioElement
          specificClass={styles.firstRadio}
          state={paymentType}
          setState={setPaymentType}
          fieldToCheck={PaymentTypeE.CREDIT_CARD}
          textRadioObject={getTextByKey("credit-card-text")}
          tooltipRadio={null}
        />

        <RadioElement
          state={paymentType}
          setState={setPaymentType}
          fieldToCheck={PaymentTypeE.PAYPAL}
          textRadioObject={<Image name="purchases/paypal-button" ext="png" />}
          tooltipRadio={null}
        />
      </div>
    </>
  );
});
export default FirstStepSection;
